  <div class="close-btn-outer text-right">
    <button mat-raised-button color="primary" (click)="close()">
      Close<mat-icon class="ml-0 mr-0">close</mat-icon>
    </button>
  </div>
  <div class="d-flex flex-row flex-wrap zoom-control">
    <div class="flex-100 flex-fill text-center mb-3">
      <button mat-mini-fab color="primary" (click)="zoomOut(20)"><mat-icon>zoom_out</mat-icon></button>
      <span class="d-inline-block ml-3 mr-3">Zoom Level - {{zoomLevel}}%</span>
      <button mat-mini-fab color="primary" (click)="zoomIn(20)"><mat-icon>zoom_in</mat-icon></button>
      <br />
      <span class="zoom-warn" *ngIf="blurr">You are zooming beyond the size of the image. Image quality may suffer</span>
      <span class="zoom-warn" *ngIf="!blurr">&nbsp;</span>
    </div>
  </div>
  <div mat-dialog-content id="zoomContainer">
    <img id="zoomImage" [defaultImage]="settings?.holdingImage?.medium" (onStateChange)="imageStateChange($event)" [lazyLoad]="image?.full" alt="Zoomed Image" [style.width]="imageWidth">
  </div>
